import { getCachedToken, getHost } from '../../utils/tokenService';
import { SEARCH_METADATA_API_ENDPOINT } from '../../constants';
import { apiJson } from './api-jsons';

export const fetchLiveboardList = async () => {
  try {
    const token = await getCachedToken();

    const response = await fetch(`${getHost()}${SEARCH_METADATA_API_ENDPOINT}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ...apiJson,
        metadata: [
          {
            type: 'LIVEBOARD',
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    const liveboards = data.map((liveboard: any) => ({
      id: liveboard.metadata_id,
      name: liveboard.metadata_name,
      description: liveboard.metadata_header?.description || '',
    }));

    // dispatch({ type: 'updateLiveboardList', value: liveboards });

    return {
      objects: liveboards,
    };
  } catch (error) {
    return {
      objects: [],
    };
  }
};

export const fetchLiveboardListWithSearch = async (search: string) => {
  try {
    const token = await getCachedToken();

    const response = await fetch(`${getHost()}${SEARCH_METADATA_API_ENDPOINT}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ...apiJson,
        metadata: [
          {
            name_pattern: search.trim() || undefined,
            type: 'LIVEBOARD',
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    const liveboards = data.map((liveboard: any) => ({
      id: liveboard.metadata_id,
      name: liveboard.metadata_name,
      description: liveboard.metadata_header?.description || '',
    }));

    return {
      objects: liveboards,
    };
  } catch (error) {
    return {
      objects: [],
    };
  }
};

export const fetchVisualizationsForLiveboard = async (liveboardId: string) => {
  try {
    const token = await getCachedToken();
    // const { dispatch } = useVariable();

    const response = await fetch(`${getHost()}${SEARCH_METADATA_API_ENDPOINT}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ...apiJson,
        include_visualization_headers: true,
        include_visualization_data: true,
        metadata: [
          {
            identifier: liveboardId,
            type: 'LIVEBOARD',
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    const visualizations: any[] = [];
    if (data && data.length > 0) {
      const liveboard = data[0];

      if (liveboard.visualization_headers && liveboard.visualization_headers.length > 0) {
        liveboard.visualization_headers.forEach((viz: any) => {
          visualizations.push({
            id: viz.id,
            name: viz.name,
            type: viz.viz_type || 'chart',
            description: viz.description || '',
          });
        });
      }
    }

    // dispatch({ type: 'updateLiveboardVizList', value: visualizations });

    return {
      objects: visualizations,
    };
  } catch (error) {
    return {
      objects: [],
    };
  }
};

export const fetchVisualizationsWithSearch = async (liveboardId: string, search: string) => {
  try {
    const allVisualizationsResponse = await fetchVisualizationsForLiveboard(liveboardId);
    const allViz = allVisualizationsResponse.objects;

    const filteredViz = allViz.filter(
      (viz: any) =>
        viz.name.toLowerCase().includes(search.toLowerCase()) ||
        viz.description.toLowerCase().includes(search.toLowerCase()) ||
        viz.type.toLowerCase().includes(search.toLowerCase())
    );

    return {
      objects: filteredViz,
    };
  } catch (error) {
    return {
      objects: [],
    };
  }
};
